import { render } from "./commonBlobFileView.vue?vue&type=template&id=e06cc806&ts=true"
import script from "./commonBlobFileView.vue?vue&type=script&setup=true&lang=ts"
export * from "./commonBlobFileView.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/shared/commonControls/commonBlobFileView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e06cc806"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e06cc806', __exports__)) {
    api.reload('e06cc806', __exports__)
  }
  
  module.hot.accept("./commonBlobFileView.vue?vue&type=template&id=e06cc806&ts=true", () => {
    api.rerender('e06cc806', render)
  })

}


export default __exports__